<template>
  <v-flex class="ml-3" :class="component.id">
    <component :is="input.tagName" v-model="val" v-bind="input.bindings" />
  </v-flex>
</template>

<script>
import HintField from './HintField'
import Autocomplete from '@/components/inputs/Autocomplete'
export default {
  name: 'DynamicInput',
  props: {
    component: { type: Object, required: true },
    value: { default: undefined }
  },
  components: {
    HintField,
    Autocomplete
  },
  computed: {
    val: {
      get() {
        return this.value
      },
      set(value) {
        const key = this.component.id
        this.$emit('update-log', { [key]: value })
      }
    },
    input() {
      const label = this.component.label
      const options = this.component.options || []
      const inputMapping = {
        autocomplete: {
          tagName: 'Autocomplete',
          bindings: {
            component: this.component
          }
        },
        'hint-field': {
          tagName: 'HintField',
          bindings: { label, componentId: this.component.id }
        },
        'single-select': {
          tagName: 'v-select',
          bindings: {
            clearable: true,
            label,
            items: options
          }
        },
        'multi-select': {
          tagName: 'v-select',
          bindings: {
            clearable: true,
            multiple: true,
            label,
            items: options
          }
        },
        checkbox: {
          tagName: 'v-checkbox',
          bindings: {
            label
          }
        },
        'text-field': {
          tagName: 'v-text-field',
          bindings: {
            label
          }
        },
        'numeric-field': {
          tagName: 'v-text-field',
          bindings: {
            label,
            type: 'number'
          }
        },
        'text-area': {
          tagName: 'v-textarea',
          bindings: {
            label,
            outline: true
          }
        }
      }[this.component.type] || {
        tagName: 'input',
        bindings: {
          placeholder: `${this.component.id}`
        }
      }

      return inputMapping
    }
  },
  methods: {
    updateLog(value) {
      const key = this.component.id
      this.$emit('update-log', { [key]: value })
    }
  }
}
</script>
